<template>
    <div class="collection-box">
        <header>
            <div class="header">
                <div @click="go('back')">
                    <img src="@/assets/hotel/img/micon/back_cb.png" alt="back">
                </div>
                <div>
                    <p>我的收藏</p>
                </div>
            </div>
            <div 
                class="citys"
                v-if="!empty"
            >
                <span 
                    :class="activeCode==0&&'active'"
                    @click="changeCode({city_code:0})"
                >全部收藏</span>
                <span 
                    v-for="(item,index) of cityList" 
                    :key="index"
                    :class="item.city_code==activeCode&&'active'"
                    @click="changeCode(item)"
                >{{item.city_name}}</span>
            </div>
        </header>
        <main :class="iphonex&&'ios'">
            <van-list
                v-model="loading"
                :error.sync="error"
                error-text="请求失败，点击重新加载"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                v-if="!empty"
            >
                <van-swipe-cell
                    v-for="(item,index) of list"
                    :key="index"
                >
                    <ProductList
                        :setData="item"
                        @toggle="clickHotel(item.hotel_id)"
                    ></ProductList>
                    <template #right>
                        <div 
                            class="delete-btn" 
                            @click="delCollect(item,index)"
                        >
                            <span>删除</span>
                        </div>
                    </template>
                </van-swipe-cell>
            </van-list>
            <div 
                class="empty"
                v-if="empty"
            >
                <img src="@/assets/hotel/img/collection/collection_empty.png" alt="empty">
                <h3>没有收藏的酒店</h3>
                <p>快去看看有没有合适的酒店～</p>
            </div>
            <div 
                class="recommend"
                v-if="empty&&guess.length"
            >
                <h3>猜你喜欢</h3>
                <div>
                    <ProductList
                        v-for="(item,index) of guess"
                        :key="index"
                        :setData="item"
                        @toggle="clickHotel(item.hotel_id)"
                    ></ProductList>
                </div>
            </div>
        </main>
        <footer>
            <Footer active="collection"></Footer>
        </footer>
    </div>
</template>

<script>
import ProductList from '@/pages/hotel/components/product-list.vue'
import Footer from '@/pages/hotel/components/footer-nav.vue'
import { getCollectionLabel,getCollectionData,hotelCancelCollection,getGuessOrderList,getCityCode } from '@/pages/hotel/api'
import { mapMutations, mapState } from 'vuex'
    export default {
        components:{
            ProductList,Footer
        },
        data() {
            return {
                empty:false,//是否无收藏，true为空
                loading: false,//加载状态
                error:false,//错误状态
                finished: false,//结束状态
                cityList:[],//城市列表
                list:[],//收藏列表
                iphonex:false,//是不是iphonex
                coordinate:{},//定位信息
                collectionParams:{},//参数信息
                activeCode:0,
                guess:[],
                isiOSX:false,
            }
        },
        computed:{
            ...mapState({
                hoteldetail: (state) => state.hotel.hoteldetail
            }),
        },
        watch: {
            // 监听相同路由下参数变化的时候，从而实现异步刷新----只有路由发生变化时
            $route(to, from) {
            if (from.path == "/hotel/detail") {
                this.collectionParams.page = 1;
                this.list = []
                this.onLoad()
            }
            },
        },
        created() {
            //设置iphonex以上适配
            this.isiOSX = this.isIphoneX();
            sessionStorage.isiOSX = this.isiOSX;
        },
        beforeRouteLeave (to, from, next) {//缓存调整
            if(to.meta.title=='酒店详情'){
                this.$route.meta.keepAlive = true;
            }else{
                this.$route.meta.keepAlive = false;
                this.clearKeepAlive();
                this.$route.meta.keepAlive = true;
            }
            next();
        },
        activated(){
            if(this.empty){
                getCollectionData(this.collectionParams).then((res)=>{
                    if(res.total>0){
                        this.loading = false;
                        this.error = false;
                        this.finished = false;
                        getCollectionLabel().then((res)=>{
                            this.cityList = res.list;
                        })
                        this.empty = false;
                        this.onLoad();
                    }
                })
            }
        },
        mounted() {
            if(sessionStorage.isiOSX){
                this.iphonex = JSON.parse(sessionStorage.isiOSX);
            }

            if (!sessionStorage.getItem('coordinate')) {
                sessionStorage.setItem('coordinate', JSON.stringify({
                    longitude: 116.397072,
                    latitude: 39.909593
                }));
                let u = navigator.userAgent,
                    app = navigator.appVersion;
                let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器 
                let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端 
                if (isAndroid) {
                    window.setLocation = this.setLocation;
                    this.params('', '', "getLocation");
                }
                if (isiOS) {
                    dsBridge.call("getLocation", (positionObj) => {
                        this.setLocation(positionObj)
                    });
                }
            }else{
                this.coordinate = JSON.parse(sessionStorage.coordinate);
            }

            getCollectionLabel().then((res)=>{
                this.cityList = res.list;
            })
            this.collectionParams = {...this.coordinate,page:1};

            getGuessOrderList(this.coordinate).then((res)=>{
                this.guess = res.list;
            })
        },
        methods: {
            ...mapMutations(['setState']),
            onLoad() {
                this.list  = this.list.concat([{},{},{},{},{},{},{},{},{},{}])
                // 异步更新数据
                getCollectionData(this.collectionParams).then((res)=>{
                    this.list.splice(this.list.length-10,10);
                    this.list = this.list.concat(res.list);
                    // 加载状态结束
                    this.loading = false;
                    this.collectionParams.page++;
                    // 数据全部加载完成
                    if (res.list.length < 10) {
                        this.finished = true;
                        if(this.list.length==0){
                            this.empty = true;
                        }
                    }
                }).catch(()=>{
                    this.list.splice(this.list.length-10,10);
                    this.loading = false;
                    this.error = true;
                })
            },
            delCollect(item,index){//删除收藏信息
                this.list.splice(index,1);
                hotelCancelCollection(item.hotel_id);
                if(!this.list.length){
                    this.empty = true;
                }
            },
            changeCode(item){//城市选择
                if(this.activeCode == item.city_code){
                    return false;
                }
                
                this.activeCode = item.city_code;
                if(this.activeCode!=0){
                    this.collectionParams.city_code = item.city_code;
                }else{
                    delete this.collectionParams.city_code;
                }

                this.collectionParams.page = 1;
                this.error = false;
                this.finished = false;
                this.loading = false;
                this.list = [];
                // this.onLoad();
            },
            clickHotel(id){//点击去酒店详情
                this.go(`/hotel/detail?hotel_id=${id}`)
            },
            go(path){//跳转
                if(path=='back'){
                    history.go(-1);
                }else{
                    this.$router.push(path);
                }
            },
            clearKeepAlive(){//清除缓存
                if(this.$vnode && this.$vnode.parent && this.$vnode.parent.componentInstance &&this.$vnode.parent.componentInstance.cache){
                    if(this.$vnode.componentOptions){
                        var key = this.$vnode.key == null
                            ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? `::${this.$vnode.componentOptions.tag}` : '')
                            : this.$vnode.key;
                        var cache = this.$vnode.parent.componentInstance.cache;
                        var keys  = this.$vnode.parent.componentInstance.keys;

                        if (cache[key]) {
                            if (keys.length) {
                                var index = keys.indexOf(key)
                                if (index > -1) {
                                    keys.splice(index, 1)
                                }
                            }
                            delete cache[key]
                        }
                    }
                }
                this.$destroy();
            },
            setLocation(positionObj) {
                let obj = JSON.parse(positionObj);
                if (obj.longitude != '0') {
                    //设置app传来的经纬度
                    this.longitude = obj.longitude; //经度
                    this.latitude = obj.latitude; //纬度
                    sessionStorage.setItem('coordinate', JSON.stringify({
                        longitude: this.longitude,
                        latitude: this.latitude
                    }));
                    //逆向编码-经纬度转城市code
                    // window.onload=()=>{
                    this.position();
                    // }
                } else {
                    this.setState([{
                        name: 'searchCity',
                        value: {
                            name: '定位失败',
                            value: {},
                            bool: false
                        }
                    }])
                    this.hoteldetail.canTakeTaxi = false
                    this.setState([{
                        name: 'hoteldetail',
                        value: this.hoteldetail
                    }])
                }

            },
            position() {
                restapiLongitudeLatitude({
                    longitude: this.longitude,
                    latitude: this.latitude
                }).then(res => {
                    if (res.status === '1') {
                        let address = res.regeocode.addressComponent;
                        let obj = {};
                        let pname = (address.adcode).slice(0, 2);
                        let codeParams = {};
                        switch (pname) {
                            case '50':
                                ; //重庆
                            case '31':
                                ; //上海
                            case '11':
                                ; //北京
                            case '12':
                                codeParams = {
                                    "province": address.province.split('市')[0],
                                    "city": address.province.split('市')[0],
                                    "county": address.district.split('区')[0],
                                }
                                break; //天津
                            case '82':
                                ; //澳门
                            case '81': //香港
                                codeParams = {
                                    "province": address.province.split('特别行政区')[0],
                                    "city": address.province.split('特别行政区')[0],
                                    "county": address.district.split('区')[0],
                                }
                                break;
                            case '71':
                                ; //台湾
                                codeParams = {
                                    "province": address.province.split('省')[0],
                                    "city": address.province.split('省')[0],
                                    "county": address.province.split('省')[0],
                                }
                                break;
                            default:
                                codeParams = {
                                    "province": address.province.split('省')[0],
                                    "city": address.city.split('市')[0],
                                    "county": address.district.split('区')[0],
                                }
                        };
                        getCityCode(codeParams).then((res) => {
                            let name = `${codeParams.city}`;
                            this.setState([{
                                name: 'searchCity',
                                value: {
                                    name: name,
                                    value: {
                                        ...codeParams,
                                        name: name,
                                        code: res.code,
                                    },
                                    bool: true
                                }
                            }])
                        })
                        sessionStorage.position = JSON.stringify(obj);
                    } else {
                        this.setState([{
                            name: 'searchCity',
                            value: {
                                name: '定位失败',
                                value: {},
                                bool: false
                            }
                        }])
                        this.hoteldetail.canTakeTaxi = false
                        this.setState([{
                            name: 'hoteldetail',
                            value: this.hoteldetail
                        }])
                    }
                });
            },
        },  
    }
</script>

<style lang="less">
    html{
        font-size: calc(var(--sizeScale2)*10px);
    }
    html, body{
        overflow-x: inherit;
    }
</style>
<style lang="less" scoped>
    .collection-box{
        min-height: 100vh;
        height: auto;
        background-color: #fff !important;
        header{
            padding-top: 4.4rem;
            position: sticky;
            top: 0;
            left: 0;
            right: 0;
            background-color: #fff;
            z-index: 5;
            .header{
                width: 100%;
                height: 3.9rem;
                // position: fixed;
                // top: 44px;
                // left: 0;
                // right: 0;
                position: relative;
                >div:nth-of-type(1){
                    position: absolute;
                    left: 2rem;
                    top: 50%;
                    transform: translateY(-50%);
                    img{
                        width: 1.4rem;
                        height: 1.4rem;
                        vertical-align: middle;
                    }
                }
                >div:nth-of-type(2){
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translateY(-50%) translateX(-50%);
                    p{
                        text-align: center;
                        font-size: 1.8rem;
                        line-height: 2.5rem;
                        font-weight: 500;
                        color: #333;
                    }
                }
            }
            .citys{
                height: 3.6rem;
                width: 100%;
                margin: 1.3rem 0;
                white-space: nowrap;
                overflow-y: hidden;
                overflow-x: scroll;
                scrollbar-width: none; /* Firefox */
                -ms-overflow-style: none; /* IE 10+ */
                &::-webkit-scrollbar {
                    display: none; /* Chrome Safari */
                }
                span{
                    display: inline-block;
                    height: 3.6rem;
                    background-color: #EEEEEE;
                    border-radius: 0.5rem;
                    font-size: 1.4rem;
                    font-weight: 400;
                    line-height: 2rem;
                    color: #333;
                    padding: 0.8rem 1rem;
                    box-sizing: border-box;
                    vertical-align: top;
                    margin-left: 1rem;
                    &.active{
                        background-color: #108B30 !important;
                        color: #fff;
                    }
                    &:nth-of-type(1){
                        margin-left: 1.5rem;
                    }
                    &:nth-last-of-type(1){
                        margin-right: 1.5rem;
                    }
                }
            }
        }
        main{
            padding-bottom: 4.5rem;
            .delete-btn{
                width: 8rem;
                height: 100%;
                font-size: 1.5rem;
                font-weight: 400;
                color: #fff;
                background-color: #F84737;
                box-sizing: border-box;
                position: relative;
                span{
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translateX(-50%) translateY(-50%);
                }
            }
            .empty{
                text-align: center;
                padding-top:7.3rem;
                padding-bottom: 5rem;
                img{
                    width:20rem;
                    height: 20rem;
                }
                h3{
                    font-size: 1.7rem;
                    font-weight: 400;
                    color: #181818;
                    line-height: 2.4rem;
                    margin: 3rem 0 0.5rem 0;
                }
                p{
                    font-size: 1.5rem;
                    font-weight: 400;
                    color: #999999;
                    line-height: 2.1rem;
                }
            }
            .recommend{
                >h3{
                    padding: 0 2rem;
                    margin:0;
                    font-size: 1.8rem;
                    font-weight: 500;
                    color: #333;
                    line-height: 2.5rem;
                    padding-bottom: 0.5rem;
                }
                >div{
                    background-color: #fff !important;
                }
            }
            &.ios{
                padding-bottom: 8.3rem;
            }
        }
        footer{
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: #fff;
            z-index: 999;
        }
    }
</style>